var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoGrey = function SvgInfoGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7 7.25C7 6.69772 7.44772 6.25 8 6.25C8.55229 6.25 9 6.69772 9 7.25V11.5C9 12.0523 8.55229 12.5 8 12.5C7.44772 12.5 7 12.0523 7 11.5V7.25ZM8 3.25C7.44772 3.25 7 3.69772 7 4.25C7 4.80228 7.44772 5.25 8 5.25C8.55229 5.25 9 4.80228 9 4.25C9 3.69772 8.55229 3.25 8 3.25Z",
    fill: "#999999"
  })));
};
export default SvgInfoGrey;